import { render, staticRenderFns } from "./UserProfileGeneral.vue?vue&type=template&id=0b3b5b00&"
import script from "./UserProfileGeneral.vue?vue&type=script&lang=js&"
export * from "./UserProfileGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports